/*eslint-disable*/
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'

// hooks
import {
  Dialog,
  DialogContent,
  Button,
  DialogActions,
  Typography,
} from '@mui/material';
import useDialogVisibility from '../../../../hooks/useDialogVisibility';

// components
import GroupsSearch from './components/groupsSearch';
import GroupsTable from './components/groupsTable';
import ViewGroups from './components/viewGroups';
import ConfirmationDialog from '../../../confirmationDialog';
import Alert from '../../../Alert/Alert'

// hooks
import useGroups from './hooks/useGroups';

// helpers
import { isSuperAdmin } from '../../../../helpers/user';

const cancelStyle = {
  // backgroundColor: 'rgba(98, 81, 55, 0.1)',
  '&:hover': {
    backgroundColor: 'rgba(102,90,71, 0.20)',
  },
  '&:disabled': {
    backgroundColor: 'rgba(138, 115, 92, 0.05)',
  },
  '&:focus': {
    backgroundColor: 'rgba(112, 99, 79, 0.1)',
  },
}

const submitStyle = {
  backgroundColor: '#eb1700',
  '&:hover': {
    backgroundColor: '#CC1400',
  },
  '&:disabled': {
    backgroundColor: '#665A47',
  },
  '&:focus': {
    backgroundColor: '#CC1400',
  },
}

const AddGroupsModal = ({
  showModal,
  setShowModal,
  user,
  setUser,
  getSelectedGroupsCount,
}) => {
  const [selectedGroups, setSelectedGroups] = useState(user?.groups);
  const { groups, areGroupsLoading, getGroups } = useGroups();
  const isSuperAdminUser = isSuperAdmin();
  const [
    isCancelConfirmationDialogOpen,
    openCancelConfirmationDialog,
    closeCancelConfirmationDialog,
  ] = useDialogVisibility(false);
  const { t } = useTranslation()
  const [showAlert, setShowAlert] = useState(false);

  const handleClose = () => {
    const selectedGroupsCount = getSelectedGroupsCount(selectedGroups)
    if (selectedGroupsCount > 0) {
      openCancelConfirmationDialog()
    } else {
      setShowModal(false);
    }
  };

  const handleSubmit = () => {
    setUser({ ...user, groups: selectedGroups });
    setShowModal(false);
  };

  const handleSubmitCancelConfirmationDialog = () => {
    closeCancelConfirmationDialog();
    setShowModal(false);
  };

  const handleAlertClose = () => {
      setShowAlert(false)
    }

  return (
    <div>
      <Dialog open={showModal} onClose={handleClose} maxWidth="xl">
        <div style={{ display: 'flex', justifyContent: 'right', marginRight: '39px', marginTop: '10px', marginBottom: '0px !important'}}>
          <Button
            onClick={handleClose}
            type="submit"
            className="secondary-btn"
            variant="text"
            sx={{ ...cancelStyle, boxShadow: 'none', color: 'black', maxWidth: '80px' }}
          >
            {t('group-modal-close')}
          </Button>
        </div>
        <DialogContent style={{ width: '815px', overflow: 'hidden' }} sx={{ paddingTop: '0px' }}>
          <Typography style={{ fontSize: '24px', marginLeft: '12px', marginRight: '23px', marginTop: '6px', fontFamily: 'Johnson Display', fontWeight: 'bold' }}>{t('group-modal-heading')}</Typography>
          <Typography style={{ fontSize: '16px', marginLeft: '12px', marginRight: '23px', fontFamily: 'Johnson Text' }}>{t('group-modal-sub-heading')}</Typography>
          <Typography style={{ fontSize: '14px', marginLeft: '12px', marginRight: '23px', marginTop: '16px', fontFamily: 'Johnson Text' }}>{t('group-modal-search-eyebrow')}</Typography>
          <GroupsSearch getGroups={getGroups} />
          <ViewGroups
            selectedGroups={selectedGroups}
            setSelectedGroups={setSelectedGroups}
            getSelectedGroupsCount={getSelectedGroupsCount}
            displayAlert={setShowAlert}
          />
          <Alert
            alertStyle={"short-info-alert"}
            message={t('group-modal-info-alert')}
            showClose={false}
            customStyles={{
              marginTop: '14px',
              marginLeft: '12px',
              marginRight: '12px',
              width: '730px',
              textSize: '14px'
            }}
          />
          {showAlert && (
            <Alert
              alertStyle={"short-error-alert"}
              message={t('group-modal-warning-alert')}
              showClose={false}
              onClose={handleAlertClose}
              customStyles={{
                marginTop: '8px',
                marginLeft: '12px',
                marginRight: '12px',
                width: '730px',
                textSize: '14px'
              }}
            />
          )}
          <div style={{marginTop: '16px', }}>
            <GroupsTable
              groups={groups}
              areGroupsLoading={areGroupsLoading}
              selectedGroups={selectedGroups}
              setSelectedGroups={setSelectedGroups}
              getSelectedGroupsCount={getSelectedGroupsCount}
              displayAlert={setShowAlert}
            />
          </div>
          <ConfirmationDialog
            showDialog={isCancelConfirmationDialogOpen}
            onSubmit={handleSubmitCancelConfirmationDialog}
            onCancel={closeCancelConfirmationDialog}
          />
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'left', marginLeft: '28px', marginBottom: '22px' }}>
          <Button
            onClick={handleSubmit}
            type="submit"
            className="primary-btn"
            variant="contained"
            sx={{ ...submitStyle }}
            disabled={getSelectedGroupsCount(selectedGroups) === 0}
          >
            {t('group-modal-add-cta')}
          </Button>
          <Button
            onClick={handleClose}
            type="submit"
            className="secondary-btn"
            variant="text"
            sx={{ ...cancelStyle, boxShadow: 'none', color: 'black', marginLeft: '20px' }}
          >
            {t('group-modal-cancel-cta')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddGroupsModal;
